<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <DStoreNav></DStoreNav>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-form @submit.prevent="validateData">
        <div class="content-body">
          <div class="content-inside">
            <b-row no-gutters>
              <b-col sm="12" md="8">
                <div id="estore-settings" class="modal-form">
                  <div
                    v-if="loyaltyVisibility"
                    class="checkPlan"
                    :class="{
                      'd-none': loyaltyVisibility.enable_points_view == false,
                    }"
                  >
                    <b-row no-gutters>
                      <b-col sm="12" md="3">
                        <h6 class="main-label">Points</h6>
                      </b-col>
                      <b-col>
                        <div id="same-as-mechanics">
                          <b-form-checkbox
                            id="checkbox-1"
                            v-model="settings.points_same_as_merchanics"
                            name="checkbox-1"
                            value="1"
                            unchecked-value="0"
                          >
                            <label class="secondary-label mb-0"
                              >same as mechanics</label
                            >
                          </b-form-checkbox>
                        </div>
                        <div style="margin-top: 1px">
                          <span class="label-helper align-top">Earning</span>
                          <i class="guide-tooltip" id="earning-guide"></i>
                          <b-popover
                            target="earning-guide"
                            triggers="hover"
                            content="Nominate the minimum transaction value and equivalent points that customers can earn."
                          ></b-popover>
                        </div>
                        <div class="form-container">
                          <b-row no-gutters>
                            <b-col cols="7">
                              <b-row>
                                <b-col>
                                  <span class="d-block mb-2 up-label"
                                    >Currency</span
                                  >
                                </b-col>
                              </b-row>
                              <b-row no-gutters>
                                <b-col cols="1 mr-1">
                                  <i
                                    class="icon d-block"
                                    style="margin-top: 9px"
                                  >
                                    <img
                                      src="@/assets/images/mechanics/currency.svg"
                                      alt="Currency Icon"
                                    />
                                  </i>
                                </b-col>
                                <b-col class="p-1">
                                  <b-form-select
                                    v-model="settings.points_currency"
                                    :options="currencyOptions"
                                  />
                                </b-col>
                                <b-col class="p-1">
                                  <b-form-group>
                                    <b-form-input
                                      type="number"
                                      :formatter="pointsFormatter"
                                      placeholder="0"
                                      min="1"
                                      value="0"
                                      step="1"
                                      v-model="settings.points_currency_value"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col cols="1">
                              <i
                                class="icon mx-auto d-block"
                                style="margin-top: 4px"
                              >
                                <img
                                  src="@/assets/images/mechanics/convert.svg"
                                  alt="Convert Icon"
                                  style="margin-top: 36px"
                                />
                              </i>
                            </b-col>
                            <b-col>
                              <b-row>
                                <b-col>
                                  <span class="d-block mb-2 up-label"
                                    >Points</span
                                  >
                                </b-col>
                              </b-row>
                              <b-row no-gutters>
                                <b-col cols="2">
                                  <i
                                    class="icon d-block"
                                    style="margin-top: 9px"
                                  >
                                    <img
                                      src="@/assets/images/mechanics/points.svg"
                                      alt="Points Icon"
                                    />
                                  </i>
                                </b-col>
                                <b-col class="py-1">
                                  <b-form-group>
                                    <b-form-input
                                      type="number"
                                      disabled
                                      :formatter="pointsFormatter"
                                      v-model="settings.points_value"
                                      style="
                                        background-color: #e9ecef;
                                        opacity: 1;
                                      "
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <hr class="form-divider" />
                      </b-col>
                    </b-row>
                  </div>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">SKU Stock</h6>
                    </b-col>
                    <b-col>
                      <div
                        v-if="!isValid('sku')"
                        style="color: red; font-size: 10px; margin-left: 60px"
                      >
                        {{ errorMessage("sku") }}
                      </div>
                      <switches
                        v-model="settings.sku_stock"
                        theme="custom"
                        color="primary"
                        type-bold="true"
                        text-enabled="On"
                        text-disabled="Off"
                        style="top: -24px;"
                      ></switches>
                      <p class="dstore-info">
                        <img
                          src="@/assets/images/icons/info-circle.svg"
                          alt="Info Button"
                        />
                        To allow unlimited stocks for SKU’s. Turn this option off.
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider mb-4" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Recipient’s Mobile Number</h6>
                    </b-col>
                    <b-col>
                      <div
                        v-if="!isValid('sku')"
                        style="color: red; font-size: 10px; margin-left: 60px"
                      >
                        {{ errorMessage("sku") }}
                      </div>
                      <switches
                        v-model="settings.recipient_mobile_number"
                        theme="custom"
                        color="primary"
                        type-bold="true"
                        text-enabled="On"
                        text-disabled="Off"
                        style="top: -24px;"
                      ></switches>
                      <p class="dstore-info">
                        <img
                          src="@/assets/images/icons/info-circle.svg"
                          alt="Info Button"
                        />
                        To allow input recipient’s mobile number.
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider mb-4" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Product Categories</h6>
                    </b-col>
                    <b-col>
                      <div
                        v-if="!isValid('categories')"
                        style="color: red; font-size: 10px; margin-left: 60px"
                      >
                        {{ errorMessage("categories") }}
                      </div>
                      <div
                        id="category-switch"
                        class="d-block"
                        style="margin-bottom: 36px"
                        v-if="
                          env == 'Development' ||
                          env == 'Canary' ||
                          env == 'local' ||
                          env == 'Staging'
                        "
                      >
                        <switches
                          v-model="settings.category_enable"
                          theme="custom"
                          color="primary"
                          type-bold="true"
                          text-enabled="On"
                          text-disabled="Off"
                          style="position: absolute; top: -18px"
                        ></switches>
                      </div>
                      <b-row
                        no-gutters
                        v-for="(category, index) in settings.categories"
                        :key="index"
                      >
                        <b-col>
                          <b-row no-gutters>
                            <b-col>
                              <b-form-group
                                :label="'Category ' + (index + 1)"
                                class="mt-1 secondary-label"
                              >
                                <b-form-input
                                  ref="category"
                                  v-model="category.name"
                                  placeholder="Enter category"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col cols="1">
                              <img
                                src="../../assets/images/actions/delete.svg"
                                alt="Delete Button"
                                class="action-button estore-delete-category"
                                v-bind:class="{ 'd-none': index === 0 }"
                                @click="deleteCategory(index)"
                              />
                            </b-col>
                          </b-row>
                          <b-row
                            class="d-none"
                            no-gutters
                            v-for="(
                              sub_category, sub_index
                            ) in category.sub_categories"
                            :key="sub_index"
                          >
                            <b-col cols="2">
                              <label
                                for
                                class="secondary-label"
                                style="margin-top: 13px"
                                >Sub Category</label
                              >
                            </b-col>
                            <b-col>
                              <b-form-group class="mt-1">
                                <b-form-input
                                  :ref="
                                    'sub_category_' + index + '_' + sub_index
                                  "
                                  v-model="sub_category.name"
                                  placeholder="Enter sub category"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col>
                              <img
                                src="../../assets/images/actions/delete.svg"
                                alt="Delete Button"
                                class="action-button"
                                style="margin-top: 11px; margin-left: 8px"
                                v-bind:class="{
                                  'd-none':
                                    sub_index == 0 ||
                                    sub_index ==
                                      category.sub_categories.length - 1,
                                }"
                                @click="deleteSubCategory(index, sub_index)"
                              />
                              <img
                                src="../../assets/images/icons/add.svg"
                                class="action-button"
                                style="margin-top: 13px; margin-left: 10px"
                                alt="Add Icon"
                                v-bind:class="{
                                  'd-none':
                                    (sub_index == 0 &&
                                      category.sub_categories.length > 1) ||
                                    sub_index <
                                      category.sub_categories.length - 1,
                                }"
                                @click="addSubCategory(index, sub_index)"
                              />
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row no-gutters>
                        <b-col cols="11">
                          <div style="cursor: pointer" @click="addCategory()">
                            <img
                              class="branch-add-button d-inline-block"
                              src="../../assets/images/icons/add.svg"
                              alt="Add Icon"
                            />
                            <!-- <div
                        v-if="!isValid('categories')"
                        style="color: red; font-size:10px; margin-left: 60px;"
                      >{{ errorMessage('categories') }}</div>
                      <div id="category-switch" class="d-hide" style="margin-bottom: 36px;">
                        <switches
                          v-model="settings.categories_enable"
                          theme="custom"
                          color="primary"
                          type-bold="true"
                          text-enabled="On"
                          text-disabled="Off"
                          style="position: absolute; top: -18px;"
                        ></switches>
                            </div>-->
                            <label
                              style="cursor: pointer"
                              class="add-branch-label ml-2 d-inline-block align-middle"
                              >Add a Category</label
                            >
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider mb-4" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Fees</h6>
                    </b-col>
                    <b-col>
                      <div
                        id="category-switch"
                        class="d-block"
                        style="margin-bottom: 36px"
                      >
                        <switches
                          @change="showFees()"
                          v-model="settings.fees_enable"
                          theme="custom"
                          color="primary"
                          type-bold="true"
                          text-enabled="On"
                          text-disabled="Off"
                          style="position: absolute; top: -18px"
                        ></switches>
                      </div>
                      <b-row>
                        <b-col>
                          <div
                            id="fees-container"
                            class="d-none"
                            :class="{ 'd-block': settings.fees_enable }"
                          >
                            <div
                              class="fees-collapse-container mt-3"
                              v-for="(fee, index) in settings.fees"
                              :key="index"
                            >
                              <div class="fee-header">
                                <input
                                  type="text"
                                  class="fee-title"
                                  placeholder="Enter fee title"
                                  maxlength="50"
                                  v-model="fee.name"
                                  :ref="'input' + index"
                                  @click="editFeeTitle(index)"
                                />
                                <!-- <span v-else v-b-toggle="'fee'+index" class="fee-title">{{fee.name}}</span> -->
                                <label
                                  style="cursor: pointer"
                                  class="add-branch-label mx-2 d-inline-block align-middle"
                                  v-if="isFeeTitle"
                                  @click="editFeeTitle(index)"
                                  >Done</label
                                >
                                <img
                                  src="@/assets/images/actions/edit.svg"
                                  alt="Edit Icon"
                                  class="mr-2"
                                  @click="editFeeTitle(index)"
                                  style="cursor: pointer"
                                  v-else
                                />
                                <img
                                  src="../../assets/images/actions/delete.svg"
                                  alt="Delete Icon"
                                  class="mr-2"
                                  @click="
                                    deleteFee(settings.fees[index].uuid, index)
                                  "
                                  style="cursor: pointer"
                                />
                                <switches
                                  v-model="fee.active"
                                  theme="custom"
                                  color="primary"
                                  type-bold="true"
                                  text-enabled="On"
                                  text-disabled="Off"
                                  style="margin: -18px 1px"
                                ></switches>
                                <div
                                  v-b-toggle="'fee' + index"
                                  class="d-inline-block ml-3 action-button"
                                  style="width: 3%; position: relative; top: -3px;"
                                >
                                  <img
                                    src="@/assets/images/icons/collapse.svg"
                                    alt="Collapsed Icon"
                                    class="d-inline-block when-closed"
                                    style="width: 14px; height: 14px;"
                                  />
                                  <img
                                    src="@/assets/images/icons/expand.svg"
                                    alt="Expand Icon"
                                    class="d-inline-block when-opened"
                                    style="width: 14px; height: 14px;"
                                  />
                                </div>
                              </div>
                              <div class="fee-body">
                                <b-collapse
                                  :id="'fee' + index"
                                  visible
                                  class="mt-2"
                                  style="padding: 14px 24px"
                                >
                                  <b-row>
                                    <b-col cols="3">
                                      <b-form-group
                                        label="Value"
                                        class="mt-1 secondary-label"
                                      >
                                        <b-form-select
                                          v-model="fee.value_type"
                                          :options="feeOptions"
                                        ></b-form-select>
                                      </b-form-group>
                                    </b-col>
                                    <b-col cols="9">
                                      <b-form-group
                                        label="Price"
                                        class="mt-1 secondary-label"
                                      >
                                        <b-form-input
                                          v-model="fee.value"
                                          type="number"
                                          placeholder="Enter price"
                                          min="1"
                                          step=".01"
                                        ></b-form-input>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col cols="12">
                                      <div class="applicable-for-pickup">
                                        <b-form-checkbox
                                          :id="'checkbox' + index"
                                          v-model="fee.include_pickup"
                                          :name="'checkbox' + index"
                                          :value="1 === 1"
                                        >
                                          Applicable for Pick-up
                                          <i
                                            class="guide-tooltip"
                                            :id="'pick-up' + index"
                                          ></i>
                                          <b-popover
                                            :target="'pick-up' + index"
                                            triggers="hover"
                                            content="Checking this box will retain the fee value
                                                    upon checkout if delivery type is pick-up. If
                                                    unchecked, this shall set the fee value to
                                                    “0”."
                                          ></b-popover>
                                        </b-form-checkbox>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-collapse>
                              </div>
                            </div>
                            <div
                              class="mt-4"
                              style="cursor: pointer"
                              @click="addNewFee()"
                            >
                              <img
                                class="branch-add-button d-inline-block"
                                src="../../assets/images/icons/add.svg"
                                alt="Add Icon"
                              />
                              <label
                                style="cursor: pointer"
                                class="add-branch-label ml-2 d-inline-block align-middle"
                                >Add New Fee</label
                              >
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col sm="12" md="3">
                      <h6 class="main-label">Mode of Payment</h6>
                    </b-col>
                    <b-col>
                      <b-row no-gutters>
                        <b-col>
                          <b-row no-gutters>
                            <b-col>
                              <div
                                v-if="!isValid('payment_type')"
                                style="
                                  color: red;
                                  font-size: 10px;
                                  margin-bottom: 20px;
                                "
                              >
                                {{ errorMessage("payment_type") }}
                              </div>
                              <b-form-group>
                                <b-form-checkbox-group
                                  id="paymentType"
                                  v-model="settings.payment_type"
                                  :options="
                                    env == 'Development' ||
                                    env == 'Canary' ||
                                    env == 'local' ||
                                    env == 'Staging'
                                      ? paymentTypeOption
                                      : paymentTypeOptionProd
                                  "
                                  name="paymentType"
                                  stacked
                                  @change="
                                    showPaymentFacility(settings.payment_type)
                                  "
                                ></b-form-checkbox-group>
                              </b-form-group>
                              <div
                                id="bank-account-container"
                                class="d-none"
                                :class="{ 'd-block mt-2': isPaymentFacility }"
                                v-for="(bank, index) in settings.bank_accounts"
                                :key="index"
                              >
                                <div
                                  class="bank-name-container"
                                  v-b-toggle="'paymentFacility' + index"
                                >
                                  <span>{{ bank.bank }}</span>
                                  <!-- <img
                                    src="../../assets/images/actions/delete.svg"
                                    alt="Delete Icon"
                                    class="mr-3"                                    
                                    @click="deletePaymentFacility(index)"
                                  />-->
                                  <img
                                    src="@/assets/images/icons/collapse.svg"
                                    alt="Collapsed Icon"
                                    class="d-inline-block when-closed"
                                    style="width: 14px; height: 14px;"
                                  />
                                  <img
                                    src="@/assets/images/icons/expand.svg"
                                    alt="Expand Icon"
                                    class="d-inline-block when-opened"
                                    style="width: 14px; height: 14px;"
                                  />
                                </div>
                                <b-collapse
                                  :id="'paymentFacility' + index"
                                  visible
                                  class="mt-2 bank-form"
                                >
                                  <b-form-group
                                    label="Bank"
                                    class="mt-1 secondary-label"
                                  >
                                    <b-form-select
                                      v-model="bank.bank"
                                      :options="bankOptions"
                                    ></b-form-select>
                                  </b-form-group>
                                  <b-form-group
                                    label="Account Name"
                                    class="mt-1 secondary-label"
                                  >
                                    <b-form-input
                                      v-model="bank.account_name"
                                      :formatter="formatAccountName"
                                      placeholder="Enter account name"
                                    ></b-form-input>
                                  </b-form-group>
                                  <b-form-group
                                    label="Account Number"
                                    class="mt-1 secondary-label"
                                  >
                                    <b-form-input
                                      type="number"
                                      v-model="bank.account_no"
                                      :formatter="formatAccountNumber"
                                      placeholder="Enter account number"
                                    ></b-form-input>
                                  </b-form-group>
                                  <input type="hidden" v-model="bank.uuid" />
                                </b-collapse>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row
                            no-gutters
                            class="mt-4 d-none"
                            :class="{ 'd-block': isPaymentFacility }"
                          >
                            <b-col cols="11">
                              <div
                                style="cursor: pointer"
                                @click="addPaymentFacility()"
                              >
                                <img
                                  class="branch-add-button d-inline-block"
                                  src="../../assets/images/icons/add.svg"
                                  alt="Add Icon"
                                />
                                <label
                                  style="cursor: pointer"
                                  class="add-branch-label ml-2 d-inline-block align-middle"
                                  >Add Bank</label
                                >
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <hr class="form-divider" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        size="lg"
                        variant="primary"
                        class="mt-4 save-button"
                        type="submit"
                        :block="true"
                        >Save</b-button
                      >
                    </b-col>
                    <b-col cols="9"></b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col sm="12" md="4"></b-col>
            </b-row>
          </div>
        </div>
      </b-form>
      <b-modal ref="myModalRef" title="Confirm Changes">
        <p class="modal-main-message">
          Do you want to save the changes you made?
        </p>
        <div slot="modal-footer">
          <b-button
            variant="ghost"
            v-bind:disabled="loading"
            class="btn-cancel"
            style="margin-right: 0.25rem"
            @click="hideModal('delete-modal')"
            >Cancel</b-button
          >
          <b-button
            variant="primary"
            v-bind:disabled="loading"
            style="margin-left: 0.25rem"
            @click="sendForm()"
          >
            <template v-if="loading">Saving...</template>
            <template v-else>Save</template>
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import DStoreNav from "./DStoreNav.vue";
import Switches from "vue-switches";
import { mapState } from "vuex";

export default {
    name: "dstoreSettings",
    data() {
        return {
            form: {
                points_same_as_merchanics: "not_accepted",
                points_currency: "PHP",
                points_currency_value: 1,
                points_value: 0,
                store_name: "",
                store_description: "",
                category_enable: true,
                brand_categories_enable: true
            },
            currencyOptions: [
                { value: "php", text: "PHP" },
                { value: "usd", text: "USD" }
            ],
            temporaryCategoryCounter: 1,
            temporarySubCategoryCounter: 1,
            temporaryCategories: [
                {
                    id: "0",
                    uuid: null,
                    name: "",
                    sub_categories: []
                }
            ],
            temporarySubCategories: [
                [
                    {
                        id: "0-0",
                        uuid: null,
                        name: ""
                    }
                ]
            ],
            mop: "",
            brandCategories: [
                {
                    name: ""
                }
            ],
            productCategories: [
                {
                    name: ""
                }
            ],
            paymentTypeOption: [
                { text: "Cash On Delivery", value: "COD", content: "" },
                { text: "Credit Card", value: "CC", content: "" },
                { text: "Cash Payment", value: "CP", content: "" },
                { text: "GCASH", value: "GCASH", content: "" },
                // { text: "Bank Transfer", value: "BT", content: "" }
            ],
            paymentTypeOptionProd: [
                { text: "Cash On Delivery", value: "COD", content: "" },
                { text: "Credit Card", value: "CC", content: "" },
                { text: "GCASH", value: "GCASH", content: "" },
                // { text: "Bank Transfer", value: "BT", content: "" }
            ],
            paymentTypeSelected: [],
            paymentFacility_enable: true,
            bankOptions: [
                { text: "Asia United Bank Corporation", value: "AUB" },
                { text: "BDO Unibank, Inc.", value: "BDO" },
                { text: "Bank of Commerce", value: "BC" },
                { text: "Bank of the Philippine Islands", value: "BPI" },
                { text: "China Banking Corporation", value: "CBC" },
                { text: "CTBC Bank  (Philippines) Corporation", value: "CTBC" },
                { text: "Development Bank of the Philippines", value: "DBP" },
                { text: "East West Banking Corporation", value: "EWBC" },
                { text: "Equicom Savings Bank, Inc.", value: "ESBI" },
                { text: "Land Bank of the Philippines", value: "LBP" },
                { text: "Maybank Philippines, Incorporated", value: "MPI" },
                { text: "Metropolitan Bank & Trust Company", value: "MBTC" },
                { text: "Philippine Bank of Communications", value: "PBC" },
                { text: "Philippine National Bank", value: "PNB" },
                { text: "PNB Savings Bank", value: "PNBSB" },
                { text: "Philippine Savings Bank", value: "PSB" },
                { text: "Rizal Commercial Banking Corporation", value: "RCBC" },
                { text: "Robinsons Bank Corporation", value: "RBC" },
                { text: "Security Bank Corporation", value: "SBC" },
                {
                    text: "Sterling Bank of Asia, Inc. (A Savings Bank)",
                    value: "Sterling"
                },
                { text: "Union Bank of the Philippines", value: "UBP" },
                { text: "United Coconut Planters Bank", value: "UCPB" },
                { text: "UCPB Savings Bank", value: "UCPBSB" },
                { text: "GCASH", value: "GCASH" }
            ],
            isPaymentFacility: false,
            displayFees: true,
            isFeeTitle: false,
            feeOptions: ["PHP", "%"],
            env: process.env.VUE_APP_MODE,
            enable: true,
            radius: 8,
            enabledSku: true
        };
    },

    created() {
        this.viewSettings();
        this.getBrands();
        this.getLoyaltyVisibility();
        if (this.detail.name == "CafeFrance") this.removeGCashFromBankOptions();
    },
    computed: {
        ...mapState("dstoreSettings", [
            "loading",
            "settings",
            "errors",
            "payment_type",
            "bank_accounts",
            "brands",
            "loyaltyVisibility"
        ]),
        ...mapState("accountProfile", ["detail"])
    },
    components: {
        DStoreNav,
        Switches
    },
    watch: {
        settings: {
            deep: true,
            handler: function(value) {
                this.showPaymentFacility(value.payment_type);
            }
        }
    },
    methods: {
        removeGCashFromBankOptions() {
            for (let index = 0; index < this.bankOptions.length; index++) {
                if (this.bankOptions[index].value == "GCASH") {
                    this.bankOptions.splice(index, 1);
                }
            }
        },
        async getLoyaltyVisibility() {
            await this.$store.dispatch("dstoreSettings/getLoyaltyVisibility");
        },
        async viewSettings() {
            let _this = this;
            await this.$store
                .dispatch("dstoreSettings/viewSettings")
                .then(() => {
                    if (this.settings.limited_stock == 0) {
                        this.settings.limited_stock = false;
                        this.enabledSku = false;
                    } else {
                        this.settings.limited_stock = true;
                        this.enabledSku = true;
                    }

                    _this.checkBrandEnable();
                });
        },

        checkBrandEnable() {
            if (this.settings.brand_enable == 1) {
                this.enable = true;
            } else {
                this.enable = false;
            }
        },
        async getBrands() {
            await this.$store.dispatch("dstoreSettings/getBrands");
        },
        showPaymentFacility(paymentSelected) {
            if (paymentSelected != null) {
                if (paymentSelected.includes("BT")) {
                    return (this.isPaymentFacility = true);
                } else {
                    return (this.isPaymentFacility = false);
                }
            }
        },
        showFees() {
            return !this.displayFees;
        },
        editFeeTitle(index) {
            this.isFeeTitle = !this.isFeeTitle;
            let subCategory = "input" + index;
            let lastItem = this.$refs[subCategory];
            console.log(this.$refs);
        },
        addNewFee() {
            if (this.settings.fees.length <= 9) {
                this.settings.fees.push({
                    name: "",
                    value_type: "",
                    value: 0.0,
                    active: true,
                    include_pickup: false
                });
            } else {
                alert("Only 10 fees are allowed.");
            }
        },
        deleteFee(uuid, index) {
            this.settings.fees.splice(index, 1);
        },
        formatAccountName(e) {
            return String(e).substring(0, 50);
        },
        formatAccountNumber(e) {
            return String(e).substring(0, 20);
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors.errors[field] ? false : true;
        },
        validateData() {
            // let newBankAccounts = [];

            // if (this.settings.bank_accounts.length > 0) {
            //     newBankAccounts = _.cloneDeep(
            //         this.settings.bank_accounts.map(
            //             ({ ...keepAttrs }) => keepAttrs
            //         )
            //     );
            // }
            let allowed = true;
            // if (this.isPaymentFacility) {
            //     newBankAccounts.forEach(function(obj) {
            //         if (obj.bank == "") {
            //             alert("Bank is required.");
            //             return (allowed = false);
            //         } else if (obj.account_name == "") {
            //             alert("Account name is required.");
            //             return (allowed = false);
            //         } else if (obj.account_no == "") {
            //             alert("Account number is required.");
            //             return (allowed = false);
            //         }
            //         if (/[^a-zA-Z0-9\-\/ ]/.test(obj.account_name)) {
            //             alert(
            //                 "Special characters are not allowed for account name."
            //             );
            //             return (allowed = false);
            //         }
            //     });
            // }

            let newFees = [];

            if (this.settings.fees.length > 0) {
                newFees = _.cloneDeep(
                    this.settings.fees.map(({ ...keepAttrs }) => keepAttrs)
                );
            }

            newFees.forEach(function(obj) {
                if (obj.name == "") {
                    alert("Fee name is required.");
                    return (allowed = false);
                } else if (obj.value_type == "") {
                    alert("Value type is required.");
                    return (allowed = false);
                } else if (obj.value == "") {
                    alert("Value is required.");
                    return (allowed = false);
                }
                if (/[^a-zA-Z0-9\-\/ ]/.test(obj.name)) {
                    alert("Special characters are not allowed for Fee name.");
                    return (allowed = false);
                }
            });

            if (allowed) {
                this.showModal();
            }
        },
        async sendForm() {
            console.log(this.settings);
            let newCategories = [];
            let newBrandCategories = [];
            let newBankAccounts = [];

            if (this.settings.categories.length > 0) {
                newCategories = _.cloneDeep(
                    this.settings.categories
                        .map(({ merchant_uuid, ...keepAttrs }) => keepAttrs)
                        .filter(category => category.name != "")
                );
            }

            // if (this.settings.bank_accounts.length > 0) {
            //     newBankAccounts = _.cloneDeep(
            //         this.settings.bank_accounts.map(
            //             ({ ...keepAttrs }) => keepAttrs
            //         )
            //     );
            // }

            // if (this.settings.brand_categories.length > 0) {
            //     newBrandCategories = _.cloneDeep(
            //         this.settings.brand_categories
            //             .map(({ id, merchant_uuid, ...keepAttrs }) => keepAttrs)
            //             .filter(category => category.name != "")
            //     );
            // }

            // for (let index = 0; index < newCategories.length; index++) {
            //     newCategories[index].sub_categories = newCategories[
            //         index
            //     ].sub_categories.filter(
            //         sub_category => sub_category.name != ""
            //     );
            // }

            let newFees = [];

            if (this.settings.fees.length > 0) {
                newFees = _.cloneDeep(
                    this.settings.fees.map(({ ...keepAttrs }) => keepAttrs)
                );
            }

            // let newBrands = [];
            // if (this.brands.length > 0) {
            //     newBrands = this.brands.map(obj => {
            //         return obj.uuid;
            //     });
            // }

            this.enable ? (this.enable = 1) : (this.enable = 0);

            let param = {
                // points_same_as_merchanics: this.settings.points_same_as_merchanics,
                points_currency: this.settings.points_currency,
                points_currency_value: this.settings.points_currency_value,
                points_value: this.settings.points_value,
                recipient_mobile_number: this.settings.recipient_mobile_number
                    ? true
                    : false,
                // store_name: this.settings.store_name,
                // store_description: this.settings.store_description,
                category_enable: this.settings.category_enable,
                payment_type: this.settings.payment_type,
                categories: newCategories,
                // brand_categories_enable: this.settings.brand_categories_enable,
                // brand_categories: newBrandCategories,
                // bank_accounts: newBankAccounts,
                fees_enable: this.settings.fees_enable,
                fees: newFees,
                sku_stock: this.settings.sku_stock ? true : false
                // brands: newBrands,
                // brand_enable: this.enable,
                // radius: this.settings.radius,
                // limited_stock: this.enabledSku
            };

            let _this = this;
            await this.$store
                .dispatch("dstoreSettings/saveSettings", param)
                .then(function() {
                    if (_this.errors == null) {
                        _this.hideModal();
                        _this.viewSettings();
                        _this.mop = _this.settings.payment_type;
                    } else {
                        console.log(_this.errors);
                        _this.hideModal();
                    }
                });
        },
        pointsFormatter(value, event) {
            return event === null ? value : value * 1;
        },
        addCategory() {
            this.settings.categories.push({
                uuid: null,
                name: "",
                sub_categories: [
                    {
                        uuid: "",
                        name: ""
                    }
                ]
            });
        },
        addSubCategory(index, sub_index) {
            let subCategory = "sub_category_" + index + "_" + sub_index;
            let lastItem = this.$refs[subCategory][0].$el;
            if (lastItem.value != "") {
                this.settings.categories[index].sub_categories.push({
                    uuid: "",
                    name: ""
                });
            } else {
                lastItem.focus();
            }
        },
        deleteCategory(index) {
            this.settings.categories.splice(index, 1);
        },
        deleteSubCategory(index, sub_index) {
            this.settings.categories[index].sub_categories.splice(sub_index, 1);
        },
        addBrandCategory() {
            this.settings.brand_categories.push({
                uuid: null,
                name: "",
                sub_categories: [
                    {
                        uuid: "",
                        name: ""
                    }
                ]
            });
        },
        addBrandSubCategory(index, sub_index) {
            let subCategory = "brand_sub_category_" + index + "_" + sub_index;
            let lastItem = this.$refs[subCategory][0].$el;
            if (lastItem.value != "") {
                this.settings.brand_categories[index].sub_categories.push({
                    uuid: "",
                    name: ""
                });
            } else {
                lastItem.focus();
            }
        },
        deleteBrandCategory(index) {
            this.settings.brand_categories.splice(index, 1);
        },
        deleteBrandSubCategory(index, sub_index) {
            this.settings.brand_categories[index].sub_categories.splice(
                sub_index,
                1
            );
        },
        addPaymentFacility() {
            if (this.settings.bank_accounts.length <= 4) {
                this.settings.bank_accounts.push([
                    {
                        bank: "",
                        account_no: "",
                        account_name: "",
                        uuid: ""
                    }
                ]);
            } else {
                alert("Only 5 banks are allowed.");
            }
        },
        deletePaymentFacility(index) {
            this.settings.bank_accounts.splice(index, 1);
        },
        showModal() {
            this.$refs.myModalRef.show();
        },
        hideModal() {
            this.$refs.myModalRef.hide();
        }
    }
};
</script>
<style lang="scss">
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none !important;
}
.dstore-info {
    margin-top: -12px;
    img {
        position: relative;
        top: -3px;
        margin-right: 4px;
    }
    color: #49545c;
    font-family: MainFontRegular, sans-serif;
    font-size: 12px;
}
.applicable-for-pickup {
    .custom-control-label {
        font-size: 13px;
    }
    i {
        position: relative;
        top: 3px;
    }
}
#category-switch {
    .vue-switcher input {
        top: 14px;
        height: 25%;
    }
}
#same-as-mechanics {
    .custom-checkbox .custom-control-label::before {
        top: 5px !important;
    }
    .custom-control-label::after {
        top: 5px !important;
    }
    .secondary-label {
        color: #979797;
    }
}

#bank-account-container {
    border: 1px solid #e1e3e8;
    border-radius: 4px;
    cursor: pointer;
    .bank-name-container {
        padding: 14px 24px;
        border-bottom: 1px solid #e1e3e8;
        height: 46px;

        display: flex;
        align-items: center;

        span {
            flex: 1;
        }
    }

    .bank-form {
        padding: 14px 24px;
    }
}

#fees-container {
    .fees-collapse-container {
        border: 1px solid #e1e3e8;
        border-radius: 4px;

        .fee-header {
            display: flex;
            border-bottom: 1px solid #e1e3e8;
            height: 50px;
            padding: 14px 24px;

            .fee-title {
                flex: 1;
                border: none;
                cursor: pointer;
            }
        }
    }
}
</style>
